import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/activity/bg.png';
var _hoisted_1 = {
  class: "newcommer"
};
var _hoisted_2 = {
  class: "head"
};
var _hoisted_3 = {
  class: "head_title"
};
var _hoisted_4 = {
  class: "head_desc"
};
var _hoisted_5 = {
  key: 0,
  class: "head_price"
};
var _hoisted_6 = {
  class: "left"
};
var _hoisted_7 = {
  class: "right"
};
var _hoisted_8 = {
  key: 1,
  class: "head_precent"
};
var _hoisted_9 = {
  class: "head_precent_left"
};
var _hoisted_10 = {
  class: "head_precent_right"
};
var _hoisted_11 = {
  class: "off"
};
var _hoisted_12 = {
  class: "footer-desc"
};
var _hoisted_13 = {
  class: "task"
};
var _hoisted_14 = {
  class: "title"
};
var _hoisted_15 = {
  class: "imgStyle"
};
var _hoisted_16 = ["src"];
import { onMounted, ref, watch } from "vue";
import { priceUtil } from "@op/shared";
import NewGiftDialog from "./NewComerDialog.vue";
import { getNewcomerActivity, getNewcomerParticipate, checkNewcomerParticipate } from "@/api/reward";
import { isLogin } from "@/utils/authUtil";
import { showToast } from "@/utils/toastUtil";
import { USER_ALREADY_PARTICIPATED_ACTIVITY, ACTIVITY_NOT_START, ACTIVITY_REACH_MAX_PARTICIPATOR, ACTIVITY_ENDED, ACTIVITY_INEFFECTIVE, ACTIVITY_NO_EXISTS } from "@/constant/responseCode";
import CouponDetailPopup from "@/components/reward/CouponDetailPopup.vue";
import { DiscountTypeEnum, RedirectPageTypeMap } from "@/constant/coupon";
import { useRouter } from "@/hooks/useRouter";
import { useRoute } from "vue-router";
import { Persistent } from "@/utils/cache/persistent";
import { askPushSubscription } from "@/utils/PushSubscriptionUtil";
import { Login } from "@/components/login/LoginDialog.js";
import { useI18n } from "vue-i18n";
export default {
  __name: 'NewComer',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var companyName = ref("");
    var couponDetail = ref({
      coupon_info: {
        id: "",
        title: "",
        description: "",
        order_types: [""],
        discount_type: "",
        discount_rule: {
          currency: "",
          discount: 0,
          discount_percent: 0,
          min_consumption: 0,
          max_discount: 0
        },
        using_time_rule: {
          rule_type: "",
          expired_interval_unit: "",
          expired_interval: 0,
          when_use: ""
        }
      },
      end_time: 0,
      obtain_time: 0
    });
    var couponInfo = ref(null);
    var activityId = ref("");
    var route = useRoute();
    var isShowTask = ref(false);
    var taskImg = ref("");
    var redirect_page_type = ref("");
    var task_redirect_url = ref("");
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _route$query;
      var res, is_limit_finish_task, list, img;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            activityId.value = (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.activity_id;
            _context.next = 3;
            return getNewcomerActivity({
              activity_id: activityId.value
            });
          case 3:
            res = _context.sent;
            is_limit_finish_task = false;
            if (res.isOK && res.data) {
              companyName.value = res.data.company_name;
              couponDetail.value.coupon_info = res.data.coupon_info[0];
              couponInfo.value = res.data.coupon_info[0];
              activityId.value = res.data.activity_id;
              taskImg.value = res.data.task_link_image;
              is_limit_finish_task = res.data.is_limit_finish_task;
              redirect_page_type.value = res.data.redirect_page_type;
              task_redirect_url.value = res.data.task_redirect_url;
            }
            list = Persistent.getLocal("show_task_list");
            if (is_limit_finish_task && (!list || !list.includes(activityId.value))) {
              img = new Image();
              img.src = taskImg.value;
              img.onload = function () {
                isShowTask.value = true;
              };
            } else {
              checkParticipate();
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var showDialog = ref(false);
    function handleGoToSave() {
      return _handleGoToSave.apply(this, arguments);
    } // 登录成功
    function _handleGoToSave() {
      _handleGoToSave = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, redirectName;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!isLogin()) {
                _context2.next = 7;
                break;
              }
              _context2.next = 3;
              return getNewcomerParticipate({
                activity_id: activityId.value
              });
            case 3:
              res = _context2.sent;
              if (res.isOK && res.data) {
                // 没参与过
                showDialog.value = true;
                couponDetail.value = res.data.coupon[0];
                couponInfo.value = couponDetail.value.coupon_info;
              } else if (
              // 领取失败
              res.code === USER_ALREADY_PARTICIPATED_ACTIVITY || res.code === ACTIVITY_NOT_START || res.code === ACTIVITY_REACH_MAX_PARTICIPATOR || res.code === ACTIVITY_ENDED || res.code === ACTIVITY_INEFFECTIVE || res.code === ACTIVITY_NO_EXISTS) {
                showToast(res.reason || t("participateFailed"), 2000);
                redirectName = RedirectPageTypeMap[redirect_page_type.value] || "Index";
                setTimeout(function () {
                  routerPush({
                    name: redirectName
                  });
                }, 1000);
              }
              _context2.next = 8;
              break;
            case 7:
              handleLogin();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _handleGoToSave.apply(this, arguments);
    }
    var handleLogin = function handleLogin() {
      Login.open({
        onSuccess: function onSuccess() {
          showToast(t("loginSuccessful"));
        }
      });
    };
    var showCoupon = ref(false);
    function handleHideDialog(_x) {
      return _handleHideDialog.apply(this, arguments);
    }
    function _handleHideDialog() {
      _handleHideDialog = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(val) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              showDialog.value = val;
              _context3.next = 3;
              return askPushSubscription();
            case 3:
              showCoupon.value = true;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _handleHideDialog.apply(this, arguments);
    }
    watch(showCoupon, function (val) {
      if (!val) {
        setTimeout(function () {
          routerPush({
            name: "Account"
          });
        }, 300);
      }
    });
    function handleClose() {
      showDialog.value = false;
    }
    function onClick() {
      window.location.href = task_redirect_url.value;
      var list = Persistent.getLocal("show_task_list");
      if (!list) {
        Persistent.setLocal("show_task_list", [activityId.value]);
      } else {
        list.push(activityId.value);
        Persistent.setLocal("show_task_list", list);
      }
      isShowTask.value = false;
    }
    function checkParticipate() {
      return _checkParticipate.apply(this, arguments);
    }
    function _checkParticipate() {
      _checkParticipate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, redirectName;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!isLogin()) {
                _context4.next = 11;
                break;
              }
              _context4.next = 3;
              return checkNewcomerParticipate({
                activity_id: activityId.value
              });
            case 3:
              res = _context4.sent;
              if (!(res.isOK && res.data)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return");
            case 8:
              if (
              // 领取失败
              res.code === USER_ALREADY_PARTICIPATED_ACTIVITY || res.code === ACTIVITY_NOT_START || res.code === ACTIVITY_REACH_MAX_PARTICIPATOR || res.code === ACTIVITY_ENDED || res.code === ACTIVITY_INEFFECTIVE || res.code === ACTIVITY_NO_EXISTS) {
                showToast(res.reason || t("participateFailed"), 2000);
                redirectName = RedirectPageTypeMap[redirect_page_type.value] || "Index";
                setTimeout(function () {
                  routerPush({
                    name: redirectName
                  });
                }, 1000);
              }
            case 9:
              _context4.next = 12;
              break;
            case 11:
              return _context4.abrupt("return");
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _checkParticipate.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _couponDetail$value, _couponDetail$value2, _couponInfo$value, _couponInfo$value2, _couponInfo$value3, _couponDetail$value3, _couponInfo$value4;
      var _component_Button = _resolveComponent("Button");
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "img_style"
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("welcomeTo", [companyName.value])), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("specialNewcomerBonusForYou")), 1), (_couponDetail$value = couponDetail.value) !== null && _couponDetail$value !== void 0 && _couponDetail$value.coupon_info && ((_couponDetail$value2 = couponDetail.value) === null || _couponDetail$value2 === void 0 || (_couponDetail$value2 = _couponDetail$value2.coupon_info) === null || _couponDetail$value2 === void 0 ? void 0 : _couponDetail$value2.discount_type) === _unref(DiscountTypeEnum).FIXED ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString((_couponInfo$value = couponInfo.value) === null || _couponInfo$value === void 0 ? void 0 : _couponInfo$value.discount_rule.currency), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice((_couponInfo$value2 = couponInfo.value) === null || _couponInfo$value2 === void 0 ? void 0 : _couponInfo$value2.discount_rule.discount, (_couponInfo$value3 = couponInfo.value) === null || _couponInfo$value3 === void 0 ? void 0 : _couponInfo$value3.discount_rule.currency, false)), 1)])) : ((_couponDetail$value3 = couponDetail.value) === null || _couponDetail$value3 === void 0 || (_couponDetail$value3 = _couponDetail$value3.coupon_info) === null || _couponDetail$value3 === void 0 ? void 0 : _couponDetail$value3.discount_type) !== _unref(DiscountTypeEnum).FIXED ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(((_couponInfo$value4 = couponInfo.value) === null || _couponInfo$value4 === void 0 ? void 0 : _couponInfo$value4.discount_rule.discount_percent) * 100), 1), _createElementVNode("div", _hoisted_10, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "precent"
      }, "%", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("off")), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("newcomerBonus")), 1), _createElementVNode("div", {
        class: "btn",
        onClick: handleGoToSave
      })])]), _createVNode(NewGiftDialog, {
        show: showDialog.value,
        detail: couponInfo.value,
        "company-name": companyName.value,
        "end-time": couponDetail.value.end_time,
        "onUpdate:show": handleHideDialog,
        onClose: handleClose
      }, null, 8, ["show", "detail", "company-name", "end-time"]), _createVNode(CouponDetailPopup, {
        show: showCoupon.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return showCoupon.value = $event;
        }),
        coupon: couponDetail.value,
        type: "my"
      }, null, 8, ["show", "coupon"]), _createVNode(_component_van_popup, {
        show: isShowTask.value,
        style: {
          "border-radius": "12px",
          "background": "#fff"
        }
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("getVoucher")), 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
            src: taskImg.value,
            class: "my-img"
          }, null, 8, _hoisted_16)]), _createVNode(_component_Button, {
            class: "btn",
            onClick: onClick
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("getVoucher")), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
};